export default {"src":"/_next/static/media/IconLargeAdventurePants.94c33fc4.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};